import React from "react";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import ProductListOneSearch from "../components/ProductListOneSearch";
import BottomFooter from "../components/BottomFooter";
import FooterOne from "../components/FooterOne";
import { CartProvider } from "../contexts/CartContext";
import ProductListOne from "../components/ProductListOne";

const ProductSearchPage = () => {
    document.title = `Product Search | Bigmall`;
    return (
        <CartProvider>
        {/* ColorInit */}
        <ColorInit color={'bigmall'} />
    
        {/* ScrollToTop */}
        <ScrollToTop smooth color='#ef253c' />
    
        {/* Preloader */}
        {/* <Preloader /> */}
    
        {/* HeaderOne */}
        <HeaderOne />
        <div className="px-20">
        {/* ProductListOneSearch */}
        <ProductListOne pageSize={18} showLoadMore={false} />
        </div>
        {/* FooterOne */}
        <FooterOne />
    
        {/* BottomFooter */}
        <BottomFooter />
        </CartProvider>
    );
    };

export default ProductSearchPage;